import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { qk } from '@/lib/query-keys';
import { useRealtimeSubscription } from '@/lib/realtime';

/** Joins the realtime rooms of all workspaces of an account (for account-wide views like the inbox badge). */
export function LiveWorkspaces({ accountId }: { accountId: string | undefined }) {
  const workspaces = useQuery({
    queryKey: qk.accountWorkspaces(accountId ?? ''),
    queryFn: () => api.accounts.workspaces(accountId!),
    enabled: !!accountId,
  });
  return (
    <>
      {(workspaces.data ?? []).map((w) => (
        <LiveWorkspace key={w.id} workspaceId={w.id} />
      ))}
    </>
  );
}

function LiveWorkspace({ workspaceId }: { workspaceId: string }) {
  useRealtimeSubscription(workspaceId);
  return null;
}
